import { inject } from '@angular/core';
import { CanActivateFn, Router, ActivatedRouteSnapshot } from '@angular/router';
import { Auth } from '@angular/fire/auth';
import { Firestore, doc, getDoc } from '@angular/fire/firestore';
import { environment } from '../../../environments/environment';

export const RoleGuard: CanActivateFn = async (route: ActivatedRouteSnapshot) => {
  const auth         = inject(Auth);
  const firestore    = inject(Firestore);
  const router       = inject(Router);
  const allowedRoles: string[] = route.data['roles'] ?? [];

  await auth.authStateReady();

  const user = auth.currentUser;
  if (!user) {
    router.navigate(['/auth/login']);
    return false;
  }

  const tokenResult = await user.getIdTokenResult();
  let rol = tokenResult.claims['rol'] as string | undefined;

  // En desarrollo con emulador: fallback a Firestore si no hay claim
  if (!rol && !environment.production) {
    const snap = await getDoc(doc(firestore, `usuarios/${user.uid}`));
    rol = snap.data()?.['rol'] as string | undefined;
  }

  if (rol && allowedRoles.includes(rol)) return true;

  router.navigate(['/auth/login']);
  return false;
};
